import { AccountCapabilities } from 'types/capabilities/capabilities'
import { OrchestratedCustomerWallet } from 'types/customers'

export const CustomerDetailTabs = {
  OVERVIEW: 'overview',
  PAYMENT_LIMITS: 'paymentLimits',
} as const

export type CustomerDetailTab = (typeof CustomerDetailTabs)[keyof typeof CustomerDetailTabs]

export const CustomerModels = {
  EMBEDDED: 'EMBEDDED',
  NESTED: 'NESTED',
  RELIANCE: 'RELIANCE',
} as const

export type CustomerModel = (typeof CustomerModels)[keyof typeof CustomerModels]

export type ConfirmCustomerDetail = {
  label: string
  value: string
}

export type GetCustomerAddressOptions = {
  usePostalCode?: boolean
  useFullAddress?: boolean
  useAddressExcludingCountry?: boolean
}

export type CryptoSendAndReceiveOptions = {
  isCryptoSendOptionEnabled: boolean
  isCryptoReceiveOptionEnabled: boolean
  isCryptoMoveOptionEnabled: boolean
}

export type FiatPayinAndPayoutOptions = {
  isUnifiedPayoutOptionEnabled: boolean
  isFiatMoveOptionEnabled: boolean
  isFiatDepositOptionEnabled: boolean
}

export type WalletActionOptions = CryptoSendAndReceiveOptions &
  FiatPayinAndPayoutOptions & {
    isTransactionExportOptionEnabled: boolean
  }

export type UseCustomerWalletActionsProps = {
  accountCapabilities: AccountCapabilities
  customerWallet: OrchestratedCustomerWallet
  isViewOnlyRole: boolean
  customerModel: CustomerModel
}

export type GetCryptoSendAndReceiveOptionsProps = {
  customerWallet: OrchestratedCustomerWallet
  isEmbeddedOrRelianceCustomerModel: boolean
  isViewOnlyRole: boolean
  isActive: boolean
  isEpcWalletPayoutsCapabilityEnabled: boolean
  isEpcWalletPayinsCapabilityEnabled: boolean
  isEpcWalletInternalTransfersCapabilityEnabled: boolean
  supportsInternalTransfers: boolean
}

export type GetFiatPayinAndPayoutOptionsProps = {
  isEmbeddedOrRelianceCustomerModel: boolean
  isViewOnlyRole: boolean
  supportsThirdParty: boolean
  isActive: boolean
  isEpcWalletPayoutsCapabilityEnabled: boolean
  isEpcWalletPayinsCapabilityEnabled: boolean
  supportsInternalTransfers: boolean
  supportsDeposits: boolean
  isEpcWalletInternalTransfersCapabilityEnabled: boolean
}
